// Internal
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  setSubChildId,
  prefixCurriculumName,
} from "Administrator/modules/AdministratorModule";
import { getSelectedCurriculumId } from "modules/CommonSelectors";

// Relative
import DefineSubjectCredits from "./routes/DefineSubjectCredits";

// Constants
import { CREDITS_SETUP } from "Constants/stringConstants";

export default store => ({
  path: "credits-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-academicSetup-gpaAndCredits" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = getSelectedCurriculumId(state);
    const subChildId = store.dispatch(
      prefixCurriculumName({
        childId: CREDITS_SETUP,
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(subChildId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
  childRoutes: [DefineSubjectCredits(store)],
});
